var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clientMain"},[_c('ClientHeader'),_c('div',{staticClass:"body"},[_c('ClientOrders')],1),_c('div',{staticClass:"Footer"},[_c('ClientFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }